import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RouteService {
  constructor(
    private _router: Router,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {}

  navigate(path: string) {
    const production = environment['production'] as boolean;

    if (isPlatformBrowser(this.platformId)) {
      const parsedUrl = new URL(window.location.href);
      const baseUrl = parsedUrl.origin;

      if (path === 'login') {
        localStorage.clear();
        path = environment['login_url'];

        if (!production) {
          this._router.navigate([path]); // Use Angular router to redirect to login page in dev envs to prevent looping
          return;
        }
      }
      window.location.href = `${baseUrl}/${path}`; // DO NOT change this code. SSO requires window.location.href to work
    }
  }

  navigateNewTab(path: string, queryParams = {}) {
    const url = this._router.serializeUrl(
      this._router.createUrlTree([path], {
        queryParams,
      }),
    );

    isPlatformBrowser(this.platformId) && window.open(url, '_blank');
  }
}
